import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

export const selectTasksById = (state: RootState) => state.tasks.byId
export const selectTasksAllIds = (state: RootState) => state.tasks.allIds
export const selectTasksOptimistic = (state: RootState) => state.tasks.optimistic
export const selectTasksLoading = (state: RootState) => state.tasks.loading
export const selectTasksInitialized = (state: RootState) => state.tasks.initialized
export const selectTasksCompletedInitialized = (state: RootState) => state.tasks.completedInitialized
export const selectTasksError = (state: RootState) => state.tasks.error

export const selectAllTasks = createSelector(
    [selectTasksById, selectTasksAllIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectTasksWithOptimistic = createSelector(
    [selectAllTasks, selectTasksOptimistic],
    (tasks, optimistic) => [...tasks, ...Object.values(optimistic)]
)

export const selectTaskById = (state: RootState, taskId: string) =>
    state.tasks.byId[taskId]

export const selectTaskIdByNumber = (workspaceId: string, taskNumber: number) =>
    createSelector(
        [selectTasksById, selectTasksAllIds],
        (byId, allIds) => {
            const id = allIds.find((id: string) => {
                const task = byId[id]
                return task?.workspaceId === workspaceId && task?.number === taskNumber
            })
            return id ?? null
        }
    )
